import React, { Component } from 'react';
import { Grid, Row, Col, Button, Glyphicon } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { css } from 'glamor';
import { Link } from 'react-router-dom';
import StrataArchivedPropertyTable from '../utils/dataTable/StrataArchivedPropertyTable';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import request from '../../utils/Request';
import ErrorAlert from '../utils/ErrorAlert';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      properties: [],
      error: false,
      errorMessage: ''
    };
  }

  componentDidMount() {
    this.loadProperties();
  }

  restoreProperty(id) {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to restore this property?')) {
      request
        .archive(`/strataproperty/restore/${id}`)
        .then(() => {
          this.loadProperties();
        })
        .catch(() => {
          this.setState({
            error: true,
            errorMessage: 'Something went Wrong. Please try again Later.'
          });
        });
    }
  }

  deleteDocumentsandProperty(id) {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        'Are you sure you want to delete this property? All connected files will also be deleted. This CANNOT be undone.'
      )
    ) {
      request
        .delete(`/strataproperty/delete/${id}`)
        .then(() => {
          this.loadProperties();
        })
        .catch(() => {
          this.setState({
            error: true,
            errorMessage: 'Error deleting property.'
          });
        });
    }
  }

  loadProperties() {
    request
      .get('/strataproperty/archivedStrataProperties')
      .then((properties) => {
        this.setState({
          properties: properties.map((p) => ({
            ...p,
            property_link: (
              <Link to={`/strataAdmin/property/${p.id}`}>{p.buildingName}</Link>
            ),
            plan: p.strataPlanNumber,
            agent: p.strataAgentName,
            agent_phone: p.strataPhone,
            manager: p.buildingManagerName,
            manager_phone: p.buildingManagerPhone,
            button: (
              <div>
                <Button
                  bsSize="xsmall"
                  bsStyle="success"
                  onClick={() => {
                    this.restoreProperty(p.id);
                  }}>
                  <Glyphicon glyph="ok" />
                </Button>
                <Button
                  bsSize="xsmall"
                  bsStyle="danger"
                  style={{ marginLeft: 5 }}
                  onClick={() => this.deleteDocumentsandProperty(p.id)}>
                  <Glyphicon glyph="trash" />
                </Button>
              </div>
            )
          }))
        });
      })
      .catch(() => {
        toast('Could Not Load Properties.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: css({
            background: 'black'
          })
        });
      });
  }

  render() {
    return (
      <div>
        <ToastContainer />
        <div>
          <Grid>
            <Row>
              <Col md={12}>
                <h3>Strata Administration Archived Properties</h3>
              </Col>
            </Row>
          </Grid>

          <StrataArchivedPropertyTable properties={this.state.properties} />
          <div className="row">
            <div className="col-md-12 center">
              <Link
                to="/strataAdmin/dashboard"
                className="btn btn-outline btn-primary text-uppercase margin-bottom">
                Properties
              </Link>
            </div>
          </div>
          <div>
            {this.state.error ? (
              <ErrorAlert errorMessage={this.state.errorMessage} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
